<template>
	<div class="match_items" :data-text="text">
		<match-sport :type="type" v-if="hasSport('soccer')" title="Футбол" :matches="list.soccer" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('tennis')" title="Теннис" :matches="list.tennis" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('hockey')" title="Хоккей" :matches="list.hockey" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('basketball')" title="Баскетбол" :matches="list.basketball" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('volleyball')" title="Волейбол" :matches="list.volleyball" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('box')" title="Бокс" :matches="list.box" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('mma')" title="ММА" :matches="list.mma" :filter="filter"></match-sport>
		<match-sport :type="type" v-if="hasSport('biathlon')" title="Биатлон" :matches="list.biathlon" :filter="filter"></match-sport>
	</div>
</template>

<script>
	import _ from 'underscore';
	
	import MatchSport from "./MatchSport";
	
	export default {
		components: {
			MatchSport
		},
		
		props: ['list', 'filter', 'showDate', 'type'],
		
		data() {
			return {
				text: ''
			}
		},
		
		created() {
			this.initDataText();
		},
		
		methods: {
			hasSport(sport) {
				return _.has(this.list, sport);
			},
			initDataText() {
				var data = {
				biathlon: {
					inprogress: 'Нет гонок в прямом эфире',
					finished: 'Нет завершенных гонок',
					default: 'Нет гонок'
				},
				mma: {
					inprogress: 'Нет боев в прямом эфире',
					finished: 'Нет завершенных боев',
					default: 'Нет боев'
				},
				default: {
					inprogress: 'Нет матчей в прямом эфире',
					finished: 'Нет завершенных матчей',
					default: 'Нет матчей'
				}
			};
				data.box = data.mma;
				
				var type = ['biathlon', 'mma', 'box'].includes(this.type) ? this.type : 'default';
				var flter = ['inprogress', 'finished'].includes(this.filter) ? this.filter : 'default';
				
				this.text = data[type][flter];
			}
		},
	}
</script>

<style scoped>

</style>